module.exports = __webpack_public_path__ + "img/product5.7e5802f0.png";